import { serverApi } from "./serverApi";
import {
  ExecuteRequest,
  ExecuteResponse,
  TransformExecuteResponse
} from "../types/clientTypes";
import { ErrorType } from "../types/sharedTypes";

const clientService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    executeRequest: build.mutation<TransformExecuteResponse, ExecuteRequest>({
      query: (executeRequest) => ({
        url: `/client/execute-${executeRequest.method.toLowerCase()}-request`,
        method: "POST",
        body: {
          serverId: executeRequest.serverId,
          endpoint: executeRequest.endpoint,
          parameters: executeRequest.parameters,
          requestHeaders: executeRequest.requestHeader,
          body: executeRequest.body,
          responseJsonSchemaForValidation: executeRequest.responseJsonSchemaForValidation
        }
      }),
      transformResponse: (response: ExecuteResponse, meta, arg) => {
        return {
          internalId: arg.internalId,
          ...response
        };
      },
      transformErrorResponse: (baseQueryReturnValue, meta, arg): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode,
          internalId: arg.internalId
        }
      }
    }),
  })
});

export const {
  useExecuteRequestMutation
} = clientService
